/* eslint-disable react-hooks/exhaustive-deps */
import { Observation } from 'fhir/r4';
import moment from 'moment';
import { useEffect, useState } from 'react';
import * as Helpers from '../../../utils/Helpers';
import { Loader } from 'semantic-ui-react';

type CounterProps = {
    careplan: any;
    interventioncStartDate: string;
    observation?: Observation[];
    org: string;
    provenanceLoad: () => void;
    provenanceLoading?: boolean;
    tasks: any;
};

const Counter: React.FC<CounterProps> = ({
    careplan,
    interventioncStartDate,
    observation,
    org,
    provenanceLoad,
    provenanceLoading,
    tasks
}) => {
    const [programWeeks, setProgramWeeks] = useState<string>();
    const isOrganizationIONIS = org === "IONIS";

    let assessmentCompletedDate: string;
    let programWeekNumber: string;

    useEffect(() => {
        if (!interventioncStartDate /* && interventioncStartDate === false */) {
            provenanceLoad(); //for program weeks
        }
        if (interventioncStartDate) {
            assessmentCompletedDate = interventioncStartDate;
            // Find the difference in weeks between now and the assessment completion date. The
            // first week of the intervention will return a week difference in moment of 0 so we add 1.
            programWeekNumber = (moment.utc().diff(assessmentCompletedDate, 'week') + 1).toString();
        } else {
            programWeekNumber = 'NA';
        }
        //check and get on-hold observation
        let onHoldObservation = [];
        let onHoldObservationExists = false;
        if (observation?.length > 0) {
            for (let i = 0; i < observation?.length; i++) {
                let currentObs: Observation = observation[i];
                let observationHelper = new Helpers.ObservationHelper(currentObs);
                let id = observationHelper.getId();
                let obsCode = observationHelper.getCode();
                let obsCategory = observationHelper.getCategoryCode();
                if (obsCode === 'QUALIFICATION-STATUS' && obsCategory === 'member-program-on-hold-pw') {
                    onHoldObservationExists = true;
                    //get start and end date for on-hold observation
                    let startDate = observationHelper.getStartDate();
                    let endDate = observationHelper.getDueDate();
                    let onHoldWeeks = moment(endDate).diff(startDate, 'weeks');
                    let obj = {
                        id,
                        startDate,
                        endDate,
                        onHoldWeeks,
                    };
                    onHoldObservation.push(obj);
                }
            }
            if (!onHoldObservationExists) {
                //if no on-hold observation found, use the original program week number
                setProgramWeeks(programWeekNumber);
            }
        } else {
            //if no observation found, use the original program week number
            setProgramWeeks(programWeekNumber);
        }
    }, [interventioncStartDate, observation]);

    return (
        <>
            {provenanceLoading && <Loader active inline="centered" content={provenanceLoading} />}
            {!provenanceLoading && <div style={{ marginBottom: 10 }}>
                {tasks?.entry?.find(t => t.resource?.reasonCode?.text === "intervention")?.resource.status === "completed"
                    ? "program complete " + moment.utc(tasks.entry.find(t => t.resource.reasonCode.text === "intervention").resource.executionPeriod.start).local().fromNow()
                    : tasks?.entry?.find(t => t.resource?.reasonCode?.text === "intervention")?.resource.status === "failed"
                        || tasks?.entry?.find(t => t.resource?.reasonCode?.text === "intervention")?.resource.status === "cancelled"
                        ? "disenrolled " + moment.utc(tasks.entry.find(t => t.resource.reasonCode.text === "intervention").resource.executionPeriod.start).local().fromNow()
                        : careplan?.entry?.[0]?.resource?.identifier?.find(
                            (i) => i.system === "https://projectwell.io/fhir/identifiers/selected-intervention"
                        )?.value
                            ? isOrganizationIONIS
                                ? "WEEK " + programWeeks + " | enrolled " + moment(interventioncStartDate).format("MM/DD/YY")
                                : "enrolled " + moment.utc(careplan.entry[0].resource.period.start).local().fromNow()
                            : "not yet enrolled"}
            </div>}
        </>
    );
}

export default Counter;